// extracted by mini-css-extract-plugin
export default {"check-icon":"CheckIcon_check-icon__GFBJE"};